import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../error';
import { catchError } from 'rxjs/operators';
import { InsuranceCoverageModel } from './types';

@Injectable({
  providedIn: 'root',
})
export class InsuranceCoverageApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService
  ) {}

  getById = (id: number): Observable<InsuranceCoverageModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<InsuranceCoverageModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      })
    );
  };

  getByProductCategory = (id: number): Observable<InsuranceCoverageModel[]> => {
    let parameters: string[];
    parameters = ['ProductCategory', id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<InsuranceCoverageModel[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      })
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.insuranceCoverage.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
